import { rolesApi } from "../api";

const RoleService = {
    fetchRolesForSelect: async () => {
        try {
            const response = await rolesApi.fetchAll();
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtener roles activos para el dropdown.
     */
    getDropdown: async () => {
        try {
            const response = await rolesApi.fetchCustom('/dropdown');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
}

export default RoleService;